




















































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { DashboardService } from '../services/fixedOps/dashboard.service';
import { Base } from '../components/common/base';
import { CookieHelper } from '../helper/cookie.helper';
import { AccountService } from '../services/admin/account.service';
import { FaxNotificationsRoles, NotificationType, RoleType } from '../helper/enum';
import { ConversationService } from '../services/telephony/conversation.service';
import { ConversationListViewModel } from '../models/inventory/vehicle.inventory';
import { mapGetters } from 'vuex';
import { Utils } from '../helper/utils';
import { UserService } from '../services/admin/user.service';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

@Component({
  computed: {
    sideDrawer: {
      get() {
        return this.$props.drawer;
      },
      set(val) {
        this.$emit('toggle', val);
      },
    },
    ...mapGetters({ currentDisplayName: 'getUserDisplayName' }),
    ...mapGetters({ currentStoreId: 'getStoreId' }),
    ...mapGetters({ currentRoles: 'getRoles' }),
    ...mapGetters({ isTempPassword: 'getIsTempPassword' }),
    ...mapGetters({ userId: 'getUserId' }),
    ...mapGetters({ email: 'getUserEmail' }),
  },
  components: {
    notification: () => import('@/components/common/conversation.popup.vue'),
  },
  watch: {
    loading: function (val) {
      if (val === false) {
        this.init();
      }
    },
  },
  props: ['drawer', 'loading'],
})
export default class TopbarLayoutPage extends Base {
  public langs: any[] = ['en', 'fr'];

  public sideDrawer: boolean;
  public notifications: any = { unreadCount: 0 };
  public faxNotifications: any;
  public faxNotificationUnreadCount: number = 0;
  public preCsiNotificationCount: number = 0;
  public storeId: number = 0;
  public dashboardService: DashboardService = new DashboardService();
  public accountService: AccountService = new AccountService();
  public conversationService: ConversationService = new ConversationService();
  public userService: UserService = new UserService();
  public userName: string = '';
  public notificationLoading: boolean = true;
  public faxLoading: boolean = true;
  public dashboardLoading: boolean = true;
  public currentStoreId: number;
  public currentRoles: string[];
  public currentDisplayName: string;
  public isTempPassword: boolean;
  public userId: string;
  public email: string;
  public headerLogoPath: string = '';

  public msgText: [{ to: string; from: string; body: string }] = [
    {
      to: '',
      from: '',
      body: '',
    },
  ];

  public init() {
    this.storeId = this.currentStoreId;
    this.userName = this.currentDisplayName;
    // this.isUserTempPassword = this.isTempPassword;
    // this.userId = this.userId;
    // this.userEmail = this.email;

    if (this.storeId > 0) {
      this.getDashboardDetails();
      const roles = this.currentRoles;
      if (
        roles.indexOf(FaxNotificationsRoles.ARAdmin) > -1 ||
        roles.indexOf(FaxNotificationsRoles.ARUser) > -1 ||
        roles.indexOf(FaxNotificationsRoles.Advisor) > -1 ||
        roles.indexOf(FaxNotificationsRoles.DealManager) > -1
      ) {
        this.getNotifications();
        this.getFaxNotifications();
        this.getPreCsiNotifications();
      } else {
        this.faxLoading = false;
      }
    } else {
      this.faxLoading = false;
      this.notificationLoading = false;
      this.dashboardLoading = false;
    }
  }


  public setIsStore() {
    this.$store.dispatch('setIsStoreSelected', false);
    this.$router.push({ name: 'app.user.profile' });

    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'userProfile');
  }

  public async mounted(): Promise<void> {
    if (this.isTempPassword) {
      this.$router.push({
        name: 'app.account.changepassword',
        params: {
          id: this.userId,
        },
      });
      return;
    }
    const roles = this.currentRoles;
    const hasRole =
      roles.indexOf(RoleType.SuperAdmin) > -1 ||
      roles.indexOf(RoleType.TenantAdmin) > -1 ||
      roles.indexOf(RoleType.EnterpriseAdmin) > -1 ||
      roles.indexOf(RoleType.StoreAdmin) > -1;

    const userInfo = await this.userService.getLogInUserInfo();
    const email = userInfo.email;

    const that = this;
    const connection = new HubConnectionBuilder()
      .withUrl(Utils.API_WEB_HUB_URL)
      .configureLogging(LogLevel.Information)
      .build();

    connection
      .start()
      .then(function () {

        const channelId = email
          .replace('@', '')
          .replace(/\./g, '')
          .trim();

        connection
          .invoke('getConnectionIdWithoutTimeStamp', channelId)
          .then(function (connectionId) {
          })
          .catch((err) => console.error(err.toString()));
      })
      .catch(function (err) {
        console.log(err.toString());
      });

    connection.on('CardsNotification', function (message) {
      that.showNotification(
        null, null, "Card has been created for vendor " + message.vendorName, 60000
      );
    });

    connection.on('GenericEventNotification', function (res) {
      that.showNotification(
        null, null, res.message, 60000
      );
    });

    connection.on('ChatNotification', function (message) {
      that.getNotifications();

      if (location.pathname !== message.chatUrl) {
        const msgTxt = that.setLengthString(message.body);
        const url =
          "<a style='text-decoration: none' href=" +
          message.chatUrl +
          '>' +
          msgTxt +
          '</a>';
        let custName = '';
        if (message.customerName == null) {
          custName = message.from;
        } else {
          custName = message.customerName;
        }
        // that.showNotification(
        //   'info',
        //   'Message Notification',
        //   custName + ' : ' + msgTxt,
        //   10000,
        //   message.chatUrl
        // );
        this.showNotification(NotificationType.Info, custName + ' : ' + msgTxt, 'Message Notification', 10000, message.chatUrl);

      } else {
        that.msgText.push({
          to: message.to,
          from: message.from,
          body: message.body,
        });
        that.$store.dispatch('setNotificationMsg', that.msgText || []);
      }
    });

    connection.on('ExpenseNotification', function (message) {
      const expenseMessage = 'New Expense is submitted by ' + message.createdBy;
      const expenseUrlText = 'please click here to view the details.';
      // that.showNotification(
      //   'info',
      //   'Expense Notification',
      //   expenseMessage,
      //   10000,
      //   message.expenseUrl,
      //   expenseUrlText
      // );
      this.showNotification(NotificationType.Info, expenseMessage, 'Expense Notification', 10000, message.expenseUrl, expenseUrlText);

    });

      connection.on('ReceiveExternalHostNotification', function (message) {
          const type = (message?.type as NotificationType) || NotificationType.Info;
          const msg = (message?.message || '').replace(/\n/g, '<br/>');
          that.showNotification(type, msg, message?.title || '', 60000);
      });

  }
  public setLengthString(str) {
    const length = 50;
    const ending = '...';
    if (str.length > length) {
      return str.substring(0, length - ending.length) + ending;
    } else {
      return str;
    }
  }

  public ontoggle() {
    this.sideDrawer = !this.sideDrawer;
  }
  // GET DASHBOARD INFO
  public async getDashboardDetails(): Promise<void> {
    try {
      if (this.storeId && this.storeId !== 0) {
        const dashboardDetail = await this.dashboardService.getDashboardDetailsAsync();
        this.$store.dispatch('saveDashboardDetails', dashboardDetail);
        this.headerLogoPath = dashboardDetail.appHeaderLogoUri;
      }
    } finally {
      this.dashboardLoading = false;
    }
  }
  // GET FAX NOTIFICATIONS
  public async getFaxNotifications(): Promise<void> {
    try {
      const hasRole =
        this.isAuthorizedToAccess([FaxNotificationsRoles.ARAdmin]) ||
        this.isAuthorizedToAccess([FaxNotificationsRoles.ARUser]) ||
        this.isAuthorizedToAccess([FaxNotificationsRoles.Advisor]) ||
        this.isAuthorizedToAccess([FaxNotificationsRoles.DealManager]);
      if (this.storeId && hasRole) {
        const response = await this.conversationService.getFaxNotificationsAsync();
        this.faxNotifications = response;
        this.faxNotificationUnreadCount = this.faxNotifications.unreadCount;
      }
    } finally {
      this.faxLoading = false;
    }
  }
  // GET TEXT NOTIFICATIONS UNREAD COUNT
  public async getNotifications(): Promise<void> {
    try {
      if (this.storeId && this.isAuthorizedToAccess(['Advisor'])) {
        const response = await this.conversationService.getNotificationsAsync();
        this.notifications = response;
      }
    } finally {
      this.notificationLoading = false;
    }
  }


  // GET Pre Csi NOTIFICATIONS COUNT
  public async getPreCsiNotifications(): Promise<void> {
    try {
      if (this.storeId && this.isAuthorizedToAccess(['Advisor'])) {
        const response = await this.conversationService.getPreCsiNotificationsAsync();
        this.preCsiNotificationCount = response.count;
      }
    } finally {
      this.notificationLoading = false;
    }
  }

  public setlocal(locale): void {
    this.$i18n.locale = locale;
    this.$vuetify.lang.current = locale;
    // localStorage.setItem('lang', locale)
    CookieHelper.setCookie('lang', locale);
    window.location.reload(true);
  }

  public logOff(): void {
    this.accountService.logout(this);
    CookieHelper.setCookie('loggedInUserEmail', '');
    //location.href = '/app/account/Login';
  }
  public onSwitchStore(): void {
    this.$emit('switchstore');
  }
}
